"use strict";
/**
 * This file has been generated
 * DO NOT EDIT, IT MAY BE OVERWRITTEN
 */
Object.defineProperty(exports, "__esModule", { value: true });
var converter_1 = require("../converter");
var converter_2 = require("../converter");
exports.defaultConverterMapping = {
    "VariableFormat": new converter_2.VariableFormatConverter(),
    "VariableType": new converter_2.VariableTypeConverter(),
    "AvailablePowerSource": new converter_2.AvailablePowerSourceConverter(),
    "FirmwareState": new converter_2.FirmwareStateConverter(),
    "FirmwareUpdateResult": new converter_2.FirmwareUpdateResultConverter(),
    "HostProtocol": new converter_2.HostProtocolConverter(),
    "LowPowerOptimisationLevel": new converter_2.LowPowerOptimisationLevelConverter(),
    "NetworkMode": new converter_2.NetworkModeConverter(),
    "CloudConnectionMode": new converter_2.CloudConnectionModeConverter(),
    "TargetProtocol": new converter_2.TargetProtocolConverter(),
    "CoreType": new converter_2.CoreTypeConverter(),
    "NfcPairingMode": new converter_2.NfcPairingModeConverter(),
    "TargetCoreType": new converter_2.TargetCoreTypeConverter(),
    "SpecialFeature": new converter_2.SpecialFeatureConverter(),
    "NfcConnectionPriority": new converter_2.NfcConnectionPriorityConverter(),
    "AclEntry": new converter_1.AclEntryConverter(),
    "MemoryInfo": new converter_1.MemoryInfoConverter(),
    "MemoryWriteInfo": new converter_1.MemoryWriteInfoConverter(),
    "ReadWriteRights": new converter_1.ReadWriteRightsConverter(),
    "DataLogOption": new converter_1.DataLogOptionConverter(),
    "UartSettings": new converter_1.UartSettingsConverter(),
    "ProtocolConfiguration": new converter_1.ProtocolConfigurationConverter(),
    "TapVersion": new converter_1.TapVersionConverter(),
    "Lwm2mTlv": new converter_1.Lwm2mTlvConverter(),
    "InterfaceLock": new converter_1.InterfaceLockConverter(),
    "LoginCredential": new converter_1.LoginCredentialConverter(),
    "LoginCredentialHashed": new converter_1.LoginCredentialHashedConverter(),
    "ScramLoginParams": new converter_1.ScramLoginParamsConverter(),
    "ScramLoginResponseBody": new converter_1.ScramLoginResponseBodyConverter(),
    "TargetComStats": new converter_1.TargetComStatsConverter(),
    "AvailableFunction": new converter_1.AvailableFunctionConverter(),
    "MultiRequest": new converter_1.MultiRequestConverter(),
    "MultiResponse": new converter_1.MultiResponseConverter(),
    "CrcCheckBody": new converter_1.CrcCheckBodyConverter(),
    "SinglePacket": new converter_1.SinglePacketConverter(),
    "AclEntries": new converter_1.AclEntriesConverter(),
    "LoraConfig": new converter_1.LoraConfigConverter(),
    "SinglePacketPart": new converter_1.SinglePacketPartConverter(),
    "ModbusOptions": new converter_1.ModbusOptionsConverter(),
    "ModbusWriteOptions": new converter_1.ModbusWriteOptionsConverter(),
    "SinglePacketStoreInfo": new converter_1.SinglePacketStoreInfoConverter(),
    "AdpControlIn": new converter_1.AdpControlInConverter(),
    "AdpControlOut": new converter_1.AdpControlOutConverter(),
    "AdpStats": new converter_1.AdpStatsConverter(),
    "EncryptedIVCommand": new converter_1.EncryptedIVCommandConverter(),
    "EncryptedIVResponse": new converter_1.EncryptedIVResponseConverter(),
};
